export default {
      id: "pdf-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#pdf",
      toString: function () {
        return this.url;
      }
    }